import "./Philosophy.module.css";
import Navigation from "@/reusable_sections/Header";
import Methodology from "./sections/Methodology";
import Montessori from "./sections/Montessori";
import Footer from "@/reusable_sections/Footer";
export default function PhilosophyPage() {
  return <div>
      <Navigation />
      <Methodology />
      <Montessori />
      <Footer />
    </div>;
}